<div #panel *ngIf="creating && panelData" class="gauge-panel alignRow alignColumn">
    <!-- [title]="(panelData.title || panelData.nodeData.Name) ?? 'Add Node'" -->
    <div class="text-panel-title-creating alignRow">
        <span>{{(panelData.title || panelData.nodeData.Name)}} </span>
        <mat-icon [matMenuTriggerFor]="titleMenu" [matMenuTriggerData]="{panelData: panelData}">edit</mat-icon>
    </div>
    <div class="container"
        [ngStyle]="{'grid-template-columns': panelData.totalise ? '1fr' : '1fr '.repeat(panelData.datapoints.length)}">
        <ng-container *ngIf="panelData.totalise" [ngTemplateOutlet]="gauge_example"
            [ngTemplateOutletContext]="{index: 0, DPTitle: ''}" />
        <ng-container *ngIf="!panelData.totalise">
            <ng-container *ngFor="let dp of panelData.datapoints; let dpIdx = index;" [ngTemplateOutlet]="gauge_example"
                [ngTemplateOutletContext]="{index: dpIdx, DPTitle: dp.DPTitle}"></ng-container>
        </ng-container>
    </div>
    <ng-template #gauge_example let-idx="index" let-DPTitle="DPTitle">
        <div class="gauge-legend alignColumn" [ngStyle]="{'grid-template-columns': narrowPanel ? '1fr' : ''}">
            <ejs-circulargauge #gauge background="transparent" style="height: 100%; width: 100%;" centerX='50%'
                centerY='75%'>
                <e-axes>
                    <e-axis [minimum]="getAxisMaxMinForRanges(idx).min" [maximum]="getAxisMaxMinForRanges(idx).max"
                        [interval]="getAxisMaxMinForRanges(idx).interval" [startAngle]="-90" [endAngle]="90"
                        [labelStyle]="labelStyle">
                        <e-pointers>
                            <e-pointer [animation]="{enable: false}" [value]="testingValue"
                                [color]="'black'"></e-pointer>
                            <e-pointer [animation]="{enable: false}" [value]="0" [pointerWidth]="0"
                                [color]="resolveRangeColour(testingValue, idx)">
                            </e-pointer>
                        </e-pointers>
                        <e-ranges *ngIf="!panelData.ranges || panelData.ranges[0].min[idx] == undefined">
                            <e-range [start]="0" [end]="1.5" radius='90%' color='lightgreen' startWidth=25 endWidth=25
                                [opacity]="0.75"></e-range>
                            <e-range [start]="1.5" [end]="3" radius='90%' color='green' startWidth=25 endWidth=25
                                [opacity]="0.75"></e-range>
                            <e-range [start]="3" [end]="4.5" radius='90%' color='yellow' startWidth=25 endWidth=25
                                [opacity]="0.75"></e-range>
                            <e-range [start]="4.5" [end]="6" radius='90%' color='orange' startWidth=25 endWidth=25
                                [opacity]="0.75"></e-range>
                            <e-range [start]="6" [end]="7.5" radius='90%' color='salmon' startWidth=25 endWidth=25
                                [opacity]="0.75"></e-range>
                            <e-range [start]="7.5" [end]="9" radius='90%' color='red' startWidth=25 endWidth=25
                                [opacity]="0.75"></e-range>
                        </e-ranges>
                        <e-ranges *ngIf="panelData.ranges && panelData.ranges[0].min[idx] != undefined">
                            <e-range *ngFor="let range of panelData.ranges; let rangeIdx = index"
                                [start]="range.min[idx]" [end]="range.max[idx]" radius='90%'
                                [color]="range.color[idx] ?? getDefaultRangeColour(range,idx, rangeIdx)" startWidth=25
                                endWidth=25 [opacity]="0.75"></e-range>
                        </e-ranges>
                        <e-annotations>
                            <e-annotation radius="0%" [content]="annotationTemplate" [angle]="0"
                                [zIndex]="1"></e-annotation>
                        </e-annotations>
                    </e-axis>
                </e-axes>
                <ng-template #annotationTemplate>
                    <div class="gauge-annotation">
                        <div>
                            <span>{{testingValue}}</span>
                            <span class="smaller-text">{{"g"}}</span>
                        </div>
                    </div>
                </ng-template>
            </ejs-circulargauge>
            <div class="dptitle" *ngIf="DPTitle != ''">{{DPTitle}}</div>
        </div>
    </ng-template>
</div>

<div #panel *ngIf="creating && !panelData" class="gauge-panel alignRow alignColumn">
    <div class="text-panel-title alignRow">
        <span>Gauge</span>
    </div>
    <div class="gauge-legend alignColumn" [ngStyle]="{'grid-template-columns': narrowPanel ? '1fr' : ''}">
        <ejs-circulargauge #gauge background="transparent" style="height: 100%; width: 100%;" centerX='50%'
            centerY='75%'>
            <e-axes>
                <e-axis [maximum]="9" [minimum]="0" [startAngle]="-90" [endAngle]="90">
                    <e-pointers>
                        <e-pointer [value]="4.5" [color]="'black'"></e-pointer>
                    </e-pointers>
                    <e-ranges>
                        <e-range [start]="0" [end]="1.5" radius='90%' color='lightgreen' startWidth=25 endWidth=25
                            [opacity]="0.75"></e-range>
                        <e-range [start]="1.5" [end]="3" radius='90%' color='green' startWidth=25 endWidth=25
                            [opacity]="0.75"></e-range>
                        <e-range [start]="3" [end]="4.5" radius='90%' color='yellow' startWidth=25 endWidth=25
                            [opacity]="0.75"></e-range>
                        <e-range [start]="4.5" [end]="6" radius='90%' color='orange' startWidth=25 endWidth=25
                            [opacity]="0.75"></e-range>
                        <e-range [start]="6" [end]="7.5" radius='90%' color='salmon' startWidth=25 endWidth=25
                            [opacity]="0.75"></e-range>
                        <e-range [start]="7.5" [end]="9" radius='90%' color='red' startWidth=25 endWidth=25
                            [opacity]="0.75"></e-range>
                    </e-ranges>
                    <e-annotations>
                        <e-annotation radius="0%" [content]="annotationTemplate" [angle]="0"
                            [zIndex]="1"></e-annotation>
                    </e-annotations>
                </e-axis>
            </e-axes>
            <ng-template #annotationTemplate>
                <div class="gauge-annotation">
                    <div>
                        <span>{{4.5}}</span>
                        <span class="smaller-text">{{"g"}}</span>
                    </div>
                </div>
            </ng-template>
        </ejs-circulargauge>
    </div>
</div>

<div #panel *ngIf="!creating && publicPanelData[panelData.id]" class="gauge-panel alignRow alignColumn">
    <div class="text-panel-title alignRow">
        <span>{{!publicPanelData[panelData.id] ? 'Loading...' : panelData.title || panelData.nodeData.Name}}</span>
    </div>
    <div class="container"
        [ngStyle]="{'grid-template-columns': panelData.totalise ? '1fr' : '1fr '.repeat(panelData.datapoints.length)}">
        <ng-container *ngIf="panelData.totalise" [ngTemplateOutlet]="gauge"
            [ngTemplateOutletContext]="{index: 0, DPTitle: ''}" />
        <ng-container *ngIf="!panelData.totalise">
            <ng-container *ngFor="let dp of panelData.datapoints; let dpIdx = index;" [ngTemplateOutlet]="gauge"
                [ngTemplateOutletContext]="{index: dpIdx, DPTitle: dp.DPTitle}"></ng-container>
        </ng-container>
    </div>
    <ng-template #gauge let-idx="index" let-DPTitle="DPTitle">
        <div class="gauge-legend alignColumn">
            <ejs-circulargauge #gauge background="transparent" style="height: 100%; width: 100%;"
                [ngStyle]="{'height': !panelData.totalise ? '90%' : '100%'}" [legendSettings]="legendSettings"
                [margin]="margin" centerX='50%' centerY='75%'>
                <e-axes>
                    <e-axis [labelFormat]="'n0'" [minimum]="getAxisMaxMinForRanges(idx).min"
                        [maximum]="getAxisMaxMinForRanges(idx).max" [interval]="getAxisMaxMinForRanges(idx).interval"
                        [showLastLabel]="true" [labelStyle]="labelStyle" [startAngle]="-90" [endAngle]="90">
                        <!-- <e-axis> [color]="publicPanelData[panelData.id] ? publicPanelData[panelData.id].metricColours![idx] : ''" -->
                        <e-pointers>
                            <!-- *ngFor="let x of [].constructor(publicPanelData[panelData.id] ? publicPanelData[panelData.id].numberMetrics.length : 0); let idx = index" -->
                            <e-pointer [animation]="{enable: false}"
                                [value]="publicPanelData[panelData.id] ? publicPanelData[panelData.id].numberMetrics[idx] : 0"
                                [color]="'black'">
                            </e-pointer>
                            <e-pointer [animation]="{enable: false}" [value]="0" [pointerWidth]="0"
                                [color]="resolveRangeColour(publicPanelData[panelData.id] ? publicPanelData[panelData.id].numberMetrics[idx] : 0, idx)">
                            </e-pointer>
                        </e-pointers>
                        <e-ranges *ngIf="!panelData.ranges || panelData.ranges[0].min[idx] == undefined">
                            <e-range [start]="gaugeRanges[0].start"
                                [end]="(gaugeRanges[0].end - gaugeRanges[0].start) / 2" radius='90%' color='lightgreen'
                                startWidth=25 endWidth=25 [opacity]="0.75"></e-range>
                            <e-range [start]="(gaugeRanges[0].end - gaugeRanges[0].start) / 2"
                                [end]="gaugeRanges[0].end" radius='90%' color='green' startWidth=25 endWidth=25
                                [opacity]="0.75"></e-range>

                            <e-range [start]="gaugeRanges[1].start"
                                [end]="(gaugeRanges[1].start + (gaugeRanges[1].end - gaugeRanges[1].start) / 2)"
                                radius='90%' color='orange' startWidth=25 endWidth=25 [opacity]="0.75"></e-range>
                            <e-range [start]="(gaugeRanges[1].start + (gaugeRanges[1].end - gaugeRanges[1].start) / 2)"
                                [end]="gaugeRanges[1].end" radius='90%' color='darkorange' startWidth=25 endWidth=25
                                [opacity]="0.75"></e-range>

                            <e-range [start]="gaugeRanges[2].start"
                                [end]="(gaugeRanges[2].start + (gaugeRanges[2].end - gaugeRanges[2].start) / 2)"
                                radius='90%' color='salmon' startWidth=25 endWidth=25 [opacity]="0.75"></e-range>
                            <e-range [start]="(gaugeRanges[2].start + (gaugeRanges[2].end - gaugeRanges[2].start) / 2)"
                                [end]="gaugeRanges[2].end" radius='90%' color='red' startWidth=25 endWidth=25
                                [opacity]="0.75"></e-range>
                        </e-ranges>
                        <e-ranges *ngIf="panelData.ranges && panelData.ranges[0].min[idx] != undefined">
                            <e-range *ngFor="let range of panelData.ranges; let rangeIdx = index"
                                [start]="range.min[idx]" [end]="range.max[idx]" radius='90%'
                                [color]="range.color[idx] ?? getDefaultRangeColour(range,idx, rangeIdx)" startWidth=25
                                endWidth=25 [opacity]="0.75"></e-range>
                        </e-ranges>
                        <e-annotations>
                            <e-annotation radius="0%" [content]="annotationTemplate" [angle]="0"
                                [zIndex]="1"></e-annotation>
                        </e-annotations>
                    </e-axis>
                </e-axes>
                <ng-template #annotationTemplate>
                    <div class="gauge-annotation">
                        <div>
                            <span>{{publicPanelData[panelData.id] ? publicPanelData[panelData.id].numberMetrics[idx]
                                :
                                0}}</span>
                            <span class="smaller-text">{{publicPanelData[panelData.id] ?
                                publicPanelData[panelData.id].SI :
                                ""}}</span>
                        </div>
                    </div>
                </ng-template>
            </ejs-circulargauge>
            <div class="datapoint-name" *ngIf="DPTitle != ''"
                [ngClass]="{'offline-dp': (liveTimestamps[panelData.id] && liveTimestamps[panelData.id][idx]) ? liveTimestamps[panelData.id][idx].offline : false}">
                <span>{{DPTitle}}</span>
                @if(liveTimestamps.length > 0 && liveTimestamps[panelData.id][idx] && !panelData.totalise) {
                <span [innerHTML]="liveTimestamps[panelData.id][idx].html"></span>
                }
            </div>
            <!-- <div class="dptitle" *ngIf="DPTitle != ''">{{DPTitle}}</div> -->
            <!-- <ejs-numerictextbox (change)="resolveRangeColour($event.value, idx)"></ejs-numerictextbox> -->
        </div>
    </ng-template>
</div>

<div *ngIf="!creating && !publicPanelData[panelData.id]" class="spinner alignColumn">
    <img src="https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/circle-lines.gif">
</div>